import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSchool } from '../contexts/SchoolContext';
import Spinner from './Spinner';

interface SchoolProtectedRouteProps {
  children: React.ReactElement;
}

const SchoolProtectedRoute: React.FC<SchoolProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, initializing } = useSchool();
  const location = useLocation();

  if (initializing) {
    return <Spinner />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/school/login" state={{ from: location }} replace />;
  }

  return children;
};

export default SchoolProtectedRoute;
